// Centralized AWS Lambda endpoint resolution for the in-scope form submissions.
//
// Each function has a stable production URL (unchanged) and an optional staging
// URL. The active environment is derived from GATSBY_DATOCMS_ENV (the same
// build-time discriminator already used across the site): "production" -> prod
// URLs, anything else (staging/development) -> staging URLs.
//
// Staging targets the dedicated *-STG Lambda functions (their public Function
// URLs are hardcoded below, same as the production URLs). A GATSBY_*_URL_STAGING
// env var, if set, overrides the staging URL (e.g. for local testing).
//
// Note: Gatsby only inlines literal `process.env.GATSBY_*` references and only
// exposes GATSBY_-prefixed vars to the browser bundle, so every override below
// must be referenced literally (no dynamic process.env[...] lookups).

const ENV = (process.env.GATSBY_DATOCMS_ENV || 'production').toLowerCase()
const isProduction = ENV === 'production'

// Current production endpoints (public Lambda Function URLs).
const PROD = {
  subscribe: 'https://sgux6ymekio4fzfkx6go37x6i40nhzft.lambda-url.us-west-2.on.aws/',
  profileGet: 'https://n2gsixbvlh7etd4fonfmwtknwy0gjkju.lambda-url.us-west-2.on.aws/',
  profileSet: 'https://dcmzr3aynhjqbq2yidybjqe6tu0thwel.lambda-url.us-west-2.on.aws',
  sampleRequestNew: 'https://7t3dr2j3vobj5qhivadxegnzze0ijwlw.lambda-url.us-west-2.on.aws/',
  sampleFeedback: 'https://ucsrzcrurlorae47amkj5a7ure0kqtxh.lambda-url.us-west-2.on.aws/',
}

// Staging endpoints: the *-STG Lambda Function URLs (env var overrides optional).
const STAGING = {
  subscribe: process.env.GATSBY_SUBSCRIBE_URL_STAGING || 'https://ks3m7poa32zoaikbkr2ylpvy7q0xlllr.lambda-url.us-west-2.on.aws/',
  profileGet: process.env.GATSBY_PROFILE_GET_URL_STAGING || 'https://smjiikobf5ilgciirughiwwm7m0zbund.lambda-url.us-west-2.on.aws/',
  profileSet: process.env.GATSBY_PROFILE_SET_URL_STAGING || 'https://gimbh32zzri4jptamerlhwfnda0xljtb.lambda-url.us-west-2.on.aws/',
  sampleRequestNew: process.env.GATSBY_SAMPLE_REQUEST_URL_STAGING || 'https://4speemn3uvfk6iock76pukikgu0ihnen.lambda-url.us-west-2.on.aws/',
  sampleFeedback: process.env.GATSBY_SAMPLE_FEEDBACK_URL_STAGING || 'https://e4mh6dfy3zgp4l6ftbetmibsmi0xmjfk.lambda-url.us-west-2.on.aws/',
}

export const ENDPOINTS = isProduction ? PROD : STAGING
